export const COLLAPSED_WIDTH_DESKTOP = `${56 / 16}rem`
export const EXPANDED_WIDTH_PX = 256
export const EXPANDED_WIDTH = `${EXPANDED_WIDTH_PX / 16}rem`
// EXPANDED_WIDTH minus the nav's px-2 horizontal padding (8px each side)
export const EXPANDED_CONTENT_WIDTH = `${240 / 16}rem`

import library from "../icon/assets/icon-map"
import type { IconName } from "../icon/assets/icon-map"

export function matchesPath(currentPath: string, value?: string): boolean {
  if (value === undefined || value === "") return false
  const normalized = value.replace(/\/$/, "")
  return currentPath === normalized || currentPath.startsWith(normalized + "/")
}

export function matchesExactPath(currentPath: string, value?: string): boolean {
  if (value === undefined || value === "") return false
  return currentPath === value.replace(/\/$/, "")
}

const iconNames: Set<string> = new Set(library.map(entry => entry.name))

export function resolveActiveIcon(icon: IconName): IconName {
  const filled = `${icon}-filled`
  return iconNames.has(filled) ? (filled as IconName) : icon
}

const INTERACTIVE_SELECTOR =
  "a, button, [role='button'], input, select, textarea, label"

/**
 * Whether `element` is, or is nested within, an interactive control (link,
 * button, form field, etc.). Useful for click handlers on a container that
 * should ignore clicks landing on their own interactive children.
 */
export function isInteractiveElement(element: HTMLElement | null): boolean {
  return Boolean(element?.closest(INTERACTIVE_SELECTOR))
}
